var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoSsr',[_c('div',{staticClass:"atom-circle-progress",style:({
      width: _vm.size,
      height: _vm.size
    })},[_vm._t("content"),_vm._v(" "),_c('circle-progress',{ref:"progress",attrs:{"progress":_vm.progress,"size":100,"reverse":false,"line-cap":"round","fill":_vm.fill,"empty-fill":"rgba(0, 0, 0, .1)","animation-start-value":0.0,"start-angle":(-90 * Math.PI) / 180.0,"insert-mode":"append","thickness":5,"show-percent":false},on:{"vue-circle-progress":_vm.onProgress,"vue-circle-end":_vm.onProgressEnd}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }